// extracted by mini-css-extract-plugin
export default {"container":"Dental_container__QCdH1","verticalContainer":"Dental_verticalContainer__I4YVs","horizontalContainer":"Dental_horizontalContainer__tHoOy"};